/**
 * ArticlesProvider
 * Contain most logic handling with Omnitech Api
 */

import React from 'react'

import ArticlesCategoriesContext from './articles-categories-context'
import { fetchArticlesCategories } from './articles-categories-api'

export default function ArticlesCategoriesProvider({ children }) {
  const state = {
    fetchArticlesCategories,
  }

  return (
    <ArticlesCategoriesContext.Provider value={state}>
      {children}
    </ArticlesCategoriesContext.Provider>
  )
}
